import Layout from '../components/layout/Layout'

const Dashboard = () => {
  return (
    <Layout>
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Dashboard</h1>
        <p className="text-gray-600">
          Welcome to the PWC Withholding Tax Dashboard
        </p>
      </div>
    </Layout>
  )
}

export default Dashboard
